module.exports = __webpack_public_path__ + "icon_alert_75red.53610.svg";


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/@svg/icon_alert_75red.svg
// module id = ./src/_asset/sources/assets/images/@svg/icon_alert_75red.svg
// module chunks = main